module.exports = __webpack_public_path__ + "static/media/severity-grey.0c942b31.svg";